

type Props = {
  onClick: () => void;
  src: string;
  size: number;
  isActive: boolean;
};

export default function Thumb({ onClick, size, src, isActive }: Props) {
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        borderRadius: '8px',
        margin: '2px',
        outline: `2px solid ${isActive ? '#fff' : 'transparent'}`,
        objectFit: 'cover',
        objectPosition: 'center',
        flexShrink: 0,
      }}
    />
  );
}
